export const HERE_MAP_KEYS = {
  LABEL: {
    API_KEY: 'BhACdPMreotl8F5KwstvrgopRT0ibQgTUT6ouFe5haU'
  }}